// const baseurl = "http://103.186.185.77:5033/camarketing/adminportal/"
export const baseurl = "/v1/hasiniapi/admin/";
export const baseurlweb = "/v1/hasiniapi/web/";
export const imgUrl = "/";
